export default __webpack_public_path__ + "static/media/2.93db5a45.png";